<template>
    <div class="profile__inquiry_container">
      <div class="account_row">
          <div class="account_title">
          Create Your Profile
          </div>
      </div>    
    <form class="profile_form_box">  
      <div class="row_1">
         <div class="form-group">
          <label>Full Name</label>
          <input v-model=applicant.name type="text" class="form-control" >
        </div>
        <div class="form-group">
          <label>Email Address</label>
          <input v-validate="'required|email'" v-model=applicant.email type="email" class="form-control" id="email" name="email" placeholder="Enter your Email Address">
          <span>{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="row_1">
         <div class="form-group">
          <label>Phone Number</label>
          <input  v-validate="'required|max:10'" v-model=applicant.phone type="tel" class="form-control" name="phone_number" placeholder="Enter phone number">
          <span>{{ errors.first('phone_number') }}</span>
        </div>
        <div class="form-group">
          <label >Address</label>
          <input v-model=applicant.address type="text" class="form-control" id="address" >
        </div>
      </div>
     <div class="row_1">
        <div class="form-group">
        <label>Level Completed</label>
        <select class="form-control" v-model=level>
          <option value="+2">+2</option>
          <option value="Bachelors">Bachelors</option>
          <option value="Masters">Masters</option>
        </select>
        </div>
        
        <div class="form-group">
            <label >Stream</label>
            <input v-model=stream type="text" class="form-control" id="stream" >
        </div>     
      </div>
      <div class="row_1">
        <div class="form-group">
          <label>Completed Year</label>
          <input v-validate="'required|max:4'" v-model=formData.completed_year type="number" class="form-control" name="number">
        <span>{{errors.first('number')}}</span>
        </div>
        <!-- <div class="form-group">
          <label for="start">Date of Birth</label>
          <input type="date" id="start" class="form-control" name="trip-start" v-model=applicant.dob>
        </div>   -->
      </div>
      <div class="row_1">
        <div class="form-group">
          <label>Test Attended</label>
          <div class="text_attended_content">
           <label><input type="checkbox" v-model=testAttended value="IELTS">IELTS</label>
           <label><input type="checkbox" v-model=testAttended value="TOEFL">TOEFL</label>
           <label><input type="checkbox" v-model=testAttended value="SAT">SAT</label>
           <label><input type="checkbox" v-model=testAttended value="GRE">GRE</label>
           <label><input type="checkbox" v-model=testAttended value="PTE">PTE</label>
        </div>
        </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
        <div class="form-group">
          <label for="about">About You</label>
          <textarea class="form-control" v-model=formData.summary rows="5" id="about" placeholder="Say something about you"></textarea>
        </div>
    </div> 
      <div class="row_btn">
      <div class="btn_container">
        <v-btn @click.prevent=profileCreate :disabled="dataSaved" class="btn_submit">SAVE</v-btn>
       <span v-if="dataSaved" >Data saved successfully</span>
      </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
   data(){
     return {
        formData: {},
        testAttended:[],
        applicant: JSON.parse(localStorage.getItem('applicant')),
        level: '',
        stream: '',
        dataSaved: false,
     }
   },
   computed: {
     ...mapGetters(['detail'])
   },
   async mounted(){
      this.formData.student_id = this.applicant.id;
      await this.$store.dispatch('applicantDetail', this.applicant.id);
        this.formData = this.$store.getters.detail.detail;
          if(this.formData.qualification && this.formData.test_attended){
          this.level = this.formData.qualification.split(' ')[0];
          this.stream = this.formData.qualification.split(' ')[1];
          this.testAttended = this.formData.test_attended.split(', '); 
          for(let i=0;i<this.testAttended.length;i++)
          {
        this.testAttended[i]= this.testAttended[i].replace(",",'');
          }
        }
       document.title = 'Profile - Consultancy Finder';  
     },
     watch: {
       formData: {
         immediate: true,
         deep: true,
         handler(val){
           if(val){
             this.dataSaved = false;
           }
         }
       }
     },
    methods: {
     profileCreate(){ 
       this.$validator.validate().then(async result => {
          if(result){            
            let testAttendedData = '';
            this.testAttended.map(data => {
              if(data) {
                testAttendedData = `${data}, ${testAttendedData}`;
              }              
            })
            this.formData.test_attended = testAttendedData;
            this.formData.qualification= this.level+' '+this.stream;
            await this.$store.dispatch('applicantProfile', this.formData).then(res => {
              if(res){
                this.dataSaved = true;
              }
            })
            
          }
       });
     }
   }
}
</script>




// WEBPACK FOOTER //
// src/pages/Profile.vue